export const themes: string[] = ['default', 'deuteranomaly', 'tritanomaly', 'trichromacy', 'protanopia','deuteranopia','tritanopia','monochromacy','dark-mode','light-mode'];

export const setTheme =(theme: string) => {
    if(theme==="default") themes.forEach(t => document.documentElement.classList.remove(t));
    else{
        themes.forEach(t => document.documentElement.classList.remove(t));
        document.documentElement.classList.toggle(theme);
        console.log(theme)
    }
};